import axios from 'axios'

/**
 * We need a fetcher that bypasses the error catching mechanism
 * so we can avoid showing the error notification
 */
const noCatchFetcher = axios.create({
  baseURL: '/api',
})
noCatchFetcher.interceptors.response.use(undefined, undefined)

export default noCatchFetcher
